import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs, Keyboard, Zoom } from 'swiper/modules';

export default function() {
	return {
		lightboxOpen: false,
		main: null,
		lightbox: null,
		init() {
			const sliderMin = new Swiper(this.$el.querySelector('.swiper-min .swiper'), {
				modules: [Navigation, Pagination],
				spaceBetween: 12,
				slidesPerView: 3,
				watchSlidesProgress: true,
				breakpoints: {
					1100: {slidesPerView: 4}
				}
			});
			this.main = new Swiper(this.$el.querySelector('.swiper-main'), {
				modules: [Navigation, Pagination, Thumbs],
				slidesPerView: 1,
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				thumbs: {
					swiper: sliderMin,
				},
			});

			// Galerie plein écran (comme gilac.com) : clic sur l'image -> plein écran,
			// navigation au clavier (flèches), zoom, et Échap pour fermer.
			this.lightbox = new Swiper(this.$el.querySelector('.swiper-lightbox'), {
				modules: [Navigation, Keyboard, Zoom],
				slidesPerView: 1,
				spaceBetween: 30,
				zoom: true,
				keyboard: {
					enabled: true,
				},
				navigation: {
					nextEl: ".swiper-lightbox-button-next",
					prevEl: ".swiper-lightbox-button-prev",
				},
			});
		},
		openLightbox(index) {
			this.lightbox.slideTo(index ?? this.main.activeIndex, 0);
			this.lightboxOpen = true;
			document.body.style.overflow = 'hidden';
			this.$nextTick(() => this.lightbox.update());
		},
		closeLightbox() {
			if (!this.lightboxOpen) return;
			this.lightbox.zoom.out();
			this.lightboxOpen = false;
			document.body.style.overflow = '';
			// On synchronise le slider principal sur la dernière image vue en plein écran.
			this.main.slideTo(this.lightbox.activeIndex, 0);
		},
	}
}
